import type { CustomIconProps } from '../CustomIcon';

export const VaultCheckIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 40,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='6 8 28 24'
      {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M27.1258 10H17.7539C14.488 10 12.4404 12.3124 12.4404 15.5849V24.4151C12.4404 27.6876 14.4772 30 17.7539 30H27.1247C30.4015 30 32.4404 27.6876 32.4404 24.4151V15.5849C32.4404 12.3124 30.4015 10 27.1258 10Z'
        stroke='#76706D'
        strokeWidth='1.5'
      />
      <circle cx='20.4404' cy='20' r='3' stroke='#76706D' strokeWidth='1.5' />
      <circle cx='27.4404' cy='16' r='1' fill='#76706D' />
      <circle cx='27.4404' cy='24' r='1' fill='#76706D' />
      <circle cx='27.4404' cy='20' r='1' fill='#76706D' />
      <circle cx='12' cy='23' r='6' fill='#0F9F37' stroke='white' strokeWidth='2' />
      <path d='M9 22.5L11.3077 25L15 21' stroke='white' strokeWidth='1.5' />
    </svg>
  );
};
